import React, { useEffect, useState } from 'react';
import * as S from './styled';
import StepConstancy from '../steps/Constancy';
import StepCycle from '../steps/Cycle';
import StepPayment from '../steps/Payment';
import ErrorProcess from '../dialogs/ErrorProcess';
import ReusablePin from '../../../../../../reusables/Pin';
import ReusableTimeLine from '../../../../../../reusables/Timeline';
import ReusableTitle from '../../../../../../reusables/Title';
import Processing from '@/presentation/components/Processing';
import Spinner from '../../../../../../components/Spinner';
import { GoToPhotoComponent } from './Info';
import { ToggleHeader } from '../../../certificates-constancies/type1/register/components';
import ErrorMessage from '@/presentation/components/Error';

interface IProps {
  step: number;
  data: any;
  request: any;
  activatePayment: () => void;
  isLoadingActivatePayment: boolean;
  isSuccessActivatePayment: boolean;
  stepPaymentOption: number;
  clearActivatePayment: () => void;
  periodsSelectedData: any;
  isLoadingProcedureStudentStatus: boolean;
  procedureDetail: any;
  stepsCurrent: any;
  hasError?: any;
}

const Component = ({
  step,
  request,
  data,
  activatePayment,
  isLoadingActivatePayment,
  isSuccessActivatePayment,
  stepPaymentOption,
  clearActivatePayment,
  periodsSelectedData,
  isLoadingProcedureStudentStatus,
  procedureDetail,
  stepsCurrent,
  hasError = false
}: IProps) => {
  const [titles, setTitles] = useState<string[]>([]);
  const [errorProcess, setErrorProcess] = useState<boolean>(false);

  useEffect(() => {
    setTitles(
      data?.steps?.reduce((prev: any, curr: any) => [...prev, curr.name], [])
    );
  }, [data]);

  const dateOfPayment = stepsCurrent?.[1]?.date;

  if (hasError) {
    return <ErrorMessage />;
  }

  return (
    <S.Container data-testid="cmp-progress-certificate">
      {isLoadingProcedureStudentStatus ? (
        <Spinner />
      ) : (
        <>
          <Processing isOpen={isLoadingActivatePayment} />
          <ToggleHeader
            name={'Certificado de estudios'}
            amount={data?.amount}
            duration={data?.duration}
            date={data?.endDate}
            status={request?.status}
            perPeriod
            childContent={
              <>
                <ReusableTitle
                  fontSize="14px"
                  fontWeight="700"
                  lineHeight="20px"
                  title="¿Qué requisito necesito?"
                />
                <GoToPhotoComponent url="/tramites/autogestionables/registro-foto" />
                <ReusablePin
                  message={data?.pin1}
                  style={{ marginTop: '16px' }}
                />
              </>
            }
          />
          {/* <CardHeaderDropdown
            data={data}
            step={step}
            statusRequest={request?.status}
          >
            <ReusableTitle
              fontSize="14px"
              fontWeight="700"
              lineHeight="20px"
              title="¿Qué requisito necesito?"
            />
            <GoToPhotoComponent url="/tramites/autogestionables/registro-foto" />
            <ReusablePin message={data?.pin1} style={{ marginTop: '16px' }} />
          </CardHeaderDropdown> */}
          <ReusableTitle
            fontSize="18px"
            fontWeight="900"
            lineHeight="28px"
            style={{ marginTop: '32px' }}
            title="Progreso"
          />
          <ReusableTimeLine
            step={step}
            style={{ marginTop: '28px' }}
            titles={titles}
          >
            <StepCycle periodsSelectedData={periodsSelectedData} />
            <StepPayment
              active={step === 1}
              complete={step > 1}
              option={stepPaymentOption}
              activatePayment={activatePayment}
              isSuccessActivatePayment={isSuccessActivatePayment}
              clearActivatePayment={clearActivatePayment}
              periodsSelected={procedureDetail?.periodId}
              dateOfPayment={dateOfPayment}
            />
            <StepConstancy
              active={step >= 2}
              option={step - 2}
              document={request?.document}
              dateOfPayment={dateOfPayment}
              deprecated={request?.expiredFile}
              status={request?.status?.status}
            />
          </ReusableTimeLine>
        </>
      )}
      <ErrorProcess
        show={errorProcess}
        handlerClose={() => setErrorProcess(false)}
      />
    </S.Container>
  );
};

export default Component;
